module.exports = __webpack_public_path__ + "static/img/11-1.7b0174a4.jpg";